import { createElement, memo, useEffect } from '@max/max';
import { KNB } from '@nibfe/mkt-common-utils';
import { navigateToPage } from '../../utils';
const InflateModal = props => {
    const { inflateData } = props || {};
    const { isHotel, commonParams, magicalMemberCoupon, lxTrackParams, onInflateSuccess, onInflatePreviewSuccess, onInflateFail, onInflatePreviewFail, onClosed } = inflateData || {};
    const openInflateModal = () => {
        const randomStr = () => `${Math.random()}`.substring(2);
        function qs(params) {
            return Object.keys(params).filter(k => params[k] != null).map(k => `${k}=${params[k]}`).join('&');
        }
        function encode(str) {
            return str ? encodeURIComponent(str) : str;
        }
        // 通信事件名称可自定义，默认是 action_magic_member_coupon_package
        const knbActionName = `action_magic_member_openInflatePopup_maker_${randomStr()}`;
        const qsStr = qs({
            isHotel: isHotel ? 1 : 0,
            knbActionName,
            commonParamsJson: encode(JSON.stringify(commonParams)),
            magicalMemberCouponJson: encode(JSON.stringify(magicalMemberCoupon)),
            lxTrackParamsJson: encode(JSON.stringify(lxTrackParams)),
            isTransparent: 'true',
            hideLoading: 'true',
            mrn_transparent: 'true',
            mrn_hideloading: 'true',
            mrn_hideNextNavBar: 'true',
            mrn_min_version: '0.3.5'
        });
        // 通信
        if (KNB) {
            const actionMap = {
                magic_coupon_inflate_close: onClosed,
                magic_coupon_inflate_preview_success: onInflatePreviewSuccess,
                magic_coupon_inflate_preview_fail: onInflatePreviewFail,
                magic_coupon_inflate_success: onInflateSuccess,
                magic_coupon_inflate_fail: onInflateFail
            };
            KNB.ready(() => {
                KNB.subscribe({
                    // @ts-ignore
                    type: 'native',
                    action: knbActionName,
                    handle(data) {
                        if (data.data.type === 'magic_coupon_inflate_close') {
                            KNB.unsubscribe({
                                action: knbActionName
                            });
                        }
                        const fn = actionMap[data.data.type];
                        if (fn)
                            fn(data.data.data.data);
                    }
                });
            });
        }
        const url = `imeituan://www.meituan.com/mrn?mrn_biz=meishi&mrn_entry=magicmember-inflate-popup&mrn_component=main&${qsStr}`;
        navigateToPage(url);
    };
    useEffect(() => {
        openInflateModal();
    }, []);
    return <></>;
};
export default memo(InflateModal);
